import React from 'react';

interface LogoProps {
    className?: string;
    showText?: boolean;
    textClassName?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "h-10 w-auto", showText = true, textClassName = "text-2xl font-bold text-slate-900" }) => {
    return (
        <div className="flex items-center gap-2">
            <svg
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
                aria-label="Triyo Logo"
            >
                {/* Arc connecting the dots */}
                <path
                    d="M20 40 Q 50 10 80 40"
                    stroke="#FCD34D" // yellow-300/400
                    strokeWidth="4"
                    strokeLinecap="round"
                />

                {/* Three Dots */}
                <circle cx="20" cy="40" r="8" fill="#FCD34D" />
                <circle cx="50" cy="25" r="8" fill="#FCD34D" />
                <circle cx="80" cy="40" r="8" fill="#FCD34D" />

                {/* Y Shape */}
                <path
                    d="M35 50 L 50 70 L 65 50"
                    stroke="currentColor"
                    strokeWidth="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M50 70 V 90"
                    stroke="currentColor"
                    strokeWidth="10"
                    strokeLinecap="round"
                />
            </svg>
            {showText && (
                <span className={textClassName}>
                    Triyo<span className="text-yellow-400">.</span>
                </span>
            )}
        </div>
    );
};
